import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const setVisibleStations = (
  state: StationsState,
  action: PayloadAction<StationsState['visibleStations']['data']>
) => {
  state.visibleStations.data = action.payload
};
